<div class="header">
  <div>
    <h2>{{ "pages.creator.title" | translate }}</h2>
  </div>
  <!-- a <button>: the portal's button look is global on `button[nbButton]` -->
  <button
    *ngIf="state === 'ready'"
    nbButton
    type="button"
    appearance="outline"
    status="primary"
    routerLink="/creator/library"
    alAnchor="creator.library"
  >
    <nb-icon icon="archive-outline"></nb-icon>
    {{ "pages.creator.start.library" | translate }}
  </button>
</div>

<app-page-loader *ngIf="state === 'checking'"></app-page-loader>

<nb-card *ngIf="state === 'error'">
  <nb-card-body class="load-error">
    <p>{{ "pages.creator.library.loadError" | translate }}</p>
    <button nbButton status="primary" type="button" (click)="check()">{{ "pages.creator.library.retry" | translate }}</button>
  </nb-card-body>
</nb-card>

<div *ngIf="state === 'ready'" class="stage">
  <p class="hero">
    <span>{{ "pages.creator.start.hero1" | translate }}</span>
    <span>{{ "pages.creator.start.hero2" | translate }}</span>
  </p>
  <p *ngIf="supportAccess" class="page-hint support-hint">{{ "pages.creator.start.supportReadOnly" | translate }}</p>

  <div class="tiles" [attr.aria-label]="'pages.creator.start.choose' | translate" role="group">
    <button
      type="button"
      class="tile al-glass al-glass--tile"
      aria-haspopup="dialog"
      [disabled]="supportAccess"
      (click)="open('course')"
      alAnchor="creator.new-course"
    >
      <span class="al-glass__body tile__body">
        <svg class="tile__art" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <path d="M12 5.5C9.3 3.8 6.3 3.6 3 4.5v15c3.3-.9 6.3-.7 9 1m0-15c2.7-1.7 5.7-1.9 9-1v15c-3.3-.9-6.3-.7-9 1v-15Z" />
          <path d="M6.5 8.5c1.1-.1 2.1 0 3 .3m5 0c.9-.3 1.9-.4 3-.3" />
        </svg>
        <span class="tile__title">{{ "pages.creator.start.course" | translate }}</span>
        <span class="tile__text">{{ "pages.creator.start.courseText" | translate }}</span>
        <span class="tile__go" aria-hidden="true"><nb-icon icon="arrow-forward-outline"></nb-icon></span>
      </span>
    </button>
    <button
      type="button"
      class="tile al-glass al-glass--tile"
      aria-haspopup="dialog"
      [disabled]="supportAccess"
      (click)="open('exercise')"
      alAnchor="creator.new-exercise"
    >
      <span class="al-glass__body tile__body">
        <svg class="tile__art" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
          <rect height="17.6" rx="2.5" width="16" x="4" y="3.2" />
          <path d="m7.3 8.3 1.5 1.5 2.6-2.6M13.8 8.8h2.8m-9.3 6 1.5 1.5 2.6-2.6M13.8 15.3h2.8" />
        </svg>
        <span class="tile__title">{{ "pages.creator.start.exercise" | translate }}</span>
        <span class="tile__text">{{ "pages.creator.start.exerciseText" | translate }}</span>
        <span class="tile__go" aria-hidden="true"><nb-icon icon="arrow-forward-outline"></nb-icon></span>
      </span>
    </button>
  </div>

  <!-- Imports where the course editor runs: an Articulate Rise package (.zip, plan 4-01) and
       Word, PowerPoint, PDF, Markdown, text (plan 4-02); Figma is not built yet. -->
  <section
    class="dropzone"
    [class.dropzone--over]="dragging"
    [attr.aria-disabled]="importAvailable ? null : 'true'"
    [attr.aria-label]="'pages.creator.start.dropTitle' | translate"
    (dragover)="onDragOver($event)"
    (dragleave)="dragging = false"
    (drop)="onDrop($event)"
    alAnchor="creator.import"
  >
    <svg class="dropzone__icon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path d="M12 15V3m-4 4 4-4 4 4M4 14v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5" />
    </svg>
    <p class="dropzone__title">
      {{ "pages.creator.start.dropTitle" | translate }}
      <span *ngIf="!importAvailable" class="soon">{{ "pages.creator.start.soon" | translate }}</span>
    </p>
    <div class="dropzone__row">
      <ul class="formats">
        <li *ngFor="let f of formats" class="format">
          <img class="format__icon" [src]="'assets/images/creator/formats/' + f.id + '.png'" alt="" width="64" height="64" />
          <span class="format__label">{{ f.label }}</span>
        </li>
      </ul>
      <input #fileInput type="file" accept=".zip,.docx,.pptx,.pdf,.md,.txt" hidden (change)="onFileChosen(fileInput)" />
      <button
        *ngIf="importAvailable; else soonButton"
        nbButton
        appearance="outline"
        status="primary"
        type="button"
        (click)="fileInput.click()"
      >
        <nb-icon icon="upload-outline"></nb-icon>
        {{ "pages.creator.start.dropChoose" | translate }}
      </button>
      <!-- readable like every button, but only says that the import is coming -->
      <ng-template #soonButton>
        <button nbButton appearance="outline" status="primary" type="button" aria-disabled="true" (click)="importSoon()">
          <nb-icon icon="upload-outline"></nb-icon>
          {{ "pages.creator.start.dropChoose" | translate }}
        </button>
      </ng-template>
    </div>
    <p *ngIf="importAvailable" class="dropzone__hint">{{ "pages.creator.start.riseHint" | translate }}</p>
  </section>
</div>
